import i18next from 'i18next';

import {
  UPDATE_TABLE,
  GET_COLLECTION_TABLE,
  CLOSE_TAB,
  SET_ACTIVE_TAB,
  UNASSIGN_FROM_COLLECTIONS,
  ADD_TO_NEW_COLLECTION,
  COPY_TO_COLLECTION,
  COPY_TO_COLLECTION_UNSAVED,
  ASSIGN_TO_COLLECTION,
  REPLACE_TAB,
  ADD_SELECT_ITEMS,
  SET_CURRENT_TABLE_STATE,
  RESET_TABLE_AND_TABS,
  SET_CURRENT_TABLE_CELL,
  SET_TABS_TABLE_STATE,
} from "../constans";
import { tabType } from "utils/data";
import { getCurrentNamespace } from "utils/crossTabSync";

const initState = {
  tabs: [],
  currentTableState: {
    columns: [],
    rows: [],
    types: [],
    totals: [],
    filteredRows: [],
    selectedRows: [],
  },
};

const tableReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case UPDATE_TABLE:
      const currentNsForUpdate = getCurrentNamespace();
      
      const existingReportTab = state.tabs.find(
        (tab) => tab.id === 1 && tab.type === tabType.report && tab.modelId === currentNsForUpdate
      );
      
      const inactiveTabs = state.tabs
        .filter((tab) => {
          if (tab.type !== tabType.report) return true;
          if (tab.modelId && tab.modelId !== currentNsForUpdate) return true;
          return false;
        })
        .map((tab) => {
          return { ...tab, active: false };
        });

      return {
        ...state,
        tabs: [
          {
            ...payload,
            id: 1,
            type: tabType.report,
            name: i18next.t('report'),
            active: true,
            selectedItems: existingReportTab?.selectedItems || [],
            selectedRows: existingReportTab?.selectedRows || [],
            modelId: currentNsForUpdate,
            collection: {
              groupBy: payload.groups,
              properties: payload.properties,
            },
          },
          ...inactiveTabs,
        ],
      };
    case GET_COLLECTION_TABLE:
      const currentNsForCollection = getCurrentNamespace();
      const duplicateTab = state.tabs.filter(
        (tab) => tab.id === payload.collection.creationTime
      );

      const tabsWithoutActive = state.tabs.map((tab) => {
        if (tab.id !== payload.collection.creationTime) {
          return { ...tab, active: false };
        } else {
          return { ...tab, active: true };
        }
      });

      return {
        ...state,
        tabs: duplicateTab.length
          ? tabsWithoutActive
          : [
            ...tabsWithoutActive,
            {
              id: payload.collection.creationTime,
              type: tabType.saved,
              active: true,
              name: payload.collection.title,
              modelId: currentNsForCollection, // CRITICAL: Store modelId to isolate tabs between models
              color: payload.collection.color,
              collection: payload.collection,
              folder: payload.folder,
              selectedItems: [],
              selectedRows: [],
              modelId: currentNsForCollection, // CRITICAL: Store modelId to isolate tabs between models
              ...payload.tableCollection,
            },
          ],
        offSetSize: state.offSetSize,
        colapsedDash: state.colapsedDash,
      };
    case CLOSE_TAB:
      const openTabs = state.tabs.filter((tab) => payload.id !== tab.id);

      if (payload.active && openTabs.length) {
        const lastTab = openTabs.pop();
        openTabs.push({ ...lastTab, active: true });
      }

      return {
        ...state,
        tabs: [...openTabs],
      };
    case SET_ACTIVE_TAB:
      const newActiveTabs = state.tabs.map((tab) => {
        tab.selectItems = null;

        if (payload.id === tab.id) {
          return { ...tab, active: true };
        } else {
          return { ...tab, active: false };
        }
      });

      return {
        ...state,
        tabs: newActiveTabs,
      };
    case UNASSIGN_FROM_COLLECTIONS:
      const newUnassignArray = state.tabs.map((tab) => {
        if (payload.id === tab.id) {
          return { ...tab, ...payload };
        } else {
          return tab;
        }
      });

      return {
        ...state,
        tabs: newUnassignArray,
      };

    case ADD_TO_NEW_COLLECTION:
      let amountUnsavedTabs = 1;

      state.tabs.forEach((tab) => {
        if (tab.type === tabType.unsaved) {
          amountUnsavedTabs += 1;
        }
      });

      const newName = "New selection set " + amountUnsavedTabs;

      return {
        ...state,
        tabs: [
          ...state.tabs,
          {
            id: Date.now(),
            type: tabType.unsaved,
            active: false,
            name: newName,
            collection: payload.collection,
            ...payload.tableCollection,
          },
        ],
      };
    case COPY_TO_COLLECTION:
      const newCopyToArray = state.tabs.map((tab) => {
        if (tab.id === payload.id) {
          return { ...tab, ...payload.tableCollection };
        } else {
          return tab;
        }
      });

      return {
        ...state,
        tabs: newCopyToArray,
      };
    case ASSIGN_TO_COLLECTION:
      const newAssignToArray = state.tabs.map((tab) => {
        if (tab.id === payload.id) {
          return { ...tab, ...payload.tableCollection };
        } else {
          return tab;
        }
      });

      return {
        ...state,
        tabs: newAssignToArray,
      };
    case COPY_TO_COLLECTION_UNSAVED:
      const newCopyToArrayUnsaved = state.tabs.map((tab) => {
        if (tab.id === payload.id) {
          return { ...tab, ...payload.tableCollection };
        } else {
          return tab;
        }
      });

      return {
        ...state,
        tabs: newCopyToArrayUnsaved,
      };
    case REPLACE_TAB:
      const replaceTabArray = state.tabs.map((tab) => {
        if (tab.id === payload.id) {
          return {
            ...tab,
            ...payload,
            name: payload.collectionName,
            color: payload.color,
            type: "saved",
            id: payload.collection.creationTime,
          };
        } else {
          return tab;
        }
      });

      return {
        ...state,
        tabs: replaceTabArray,
      };
    case ADD_SELECT_ITEMS:
      const currentNs = getCurrentNamespace();
      
      if (payload.modelId) {
        if (!currentNs || payload.modelId !== currentNs) {
          return state;
        }
      } else {
        const tab = state.tabs.find(t => t.id === payload.id);
        const tabModelId = tab?.modelId;
        if (tabModelId) {
          if (!currentNs || currentNs !== tabModelId) {
            return state;
          }
          payload.modelId = tabModelId;
        } else if (currentNs) {
          return state;
        }
      }
      
      const updatedTabs = state.tabs.map((tab) => {
        if (tab.id !== payload.id) return tab;
        if (payload.modelId && tab.modelId !== payload.modelId) {
          return tab;
        }
        if (!payload.modelId && tab.modelId) {
          return tab;
        }
        return { ...tab, selectedItems: payload.selectedItems, modelId: payload.modelId || tab.modelId };
      });
      
      return {
        ...state,
        tabs: updatedTabs,
      };
    case SET_CURRENT_TABLE_STATE:
      if (payload.tableId !== undefined && payload.selectedRows !== undefined) {
        const { tableId, selectedRows, modelId, ...rest } = payload;
        
        const currentNsForState = getCurrentNamespace();
        
        if (modelId) {
          if (!currentNsForState || modelId !== currentNsForState) {
            return {
              ...state,
              currentTableState: { ...state.currentTableState, ...rest },
            };
          }
        } else {
          if (currentNsForState) {
            return {
              ...state,
              currentTableState: { ...state.currentTableState, ...rest },
            };
          }
        }
        
        return {
          ...state,
          tabs: state.tabs.map((tab) => {
            if (tab.id === tableId) {
              if (modelId) {
                if (tab.modelId !== modelId) {
                  return tab;
                }
                return { ...tab, selectedRows, modelId };
              }
              if (!tab.modelId && !currentNsForState) {
                return { ...tab, selectedRows };
              }
              return tab;
            }
            return tab;
          }),
          currentTableState: { ...state.currentTableState, ...rest, selectedRows: [] },
        };
      }
      
      return {
        ...state,
        currentTableState: { ...state.currentTableState, ...payload },
      };

    case SET_TABS_TABLE_STATE:
      return {
        ...state,
        tabs: state.tabs.map((tab) =>
          tab.id === 1
            ? { ...tab, ...payload }
            : tab
        ),
      };
      
    case SET_CURRENT_TABLE_CELL:
      const { columnId, lineElements, newValue } = payload;
      const currentNsForCell = getCurrentNamespace();

      const updatedRows = state.currentTableState.rows.map((row) => {
        const isSelectedElement = row.lineElements.filter(element => lineElements.includes(element));
        if (!!isSelectedElement?.length) {
          return { ...row, [columnId]: newValue }
        }
        return row
      })

      const updatedTabsForCell = state.tabs.map((tab) => {
        if (tab.id === 1) {
          if (currentNsForCell && tab.modelId && tab.modelId !== currentNsForCell) {
            return tab;
          }
          
          const updatedTabRows = (tab.rowsData || []).map((row) => {
            const isSelectedElement = (row.lineElements || []).filter(element => lineElements.includes(element));
            if (!!isSelectedElement?.length) {
              return { ...row, [columnId]: newValue }
            }
            return row
          });
          
          return { ...tab, rowsData: updatedTabRows };
        }
        return tab;
      });

      return {
        ...state,
        tabs: updatedTabsForCell,
        currentTableState: { ...state.currentTableState, rows: updatedRows },
      };
    case RESET_TABLE_AND_TABS: {
      return initState
    }
    default:
      return state;
  }
};

export default tableReducer;
